import React from 'react'
import PropTypes from 'prop-types'
import Header from 'components/header'
import Auth from 'services/auth/auth-service'

const HeaderContainer = ({ onTenantUserSelect }, { router }) => (
  <Header
    isAuthenticated={Auth.isLoggedIn}
    canCreate={Auth.canCreateWidgets}
    onLogoutClick={() => {
      /* istanbul ignore next */
      Auth.logout()
      /* istanbul ignore next */
      router.push('/login')
    }}
    username={Auth.username}
    permissions={Auth.permissions}
    profilePicUrl={Auth.profilePicUrl}
    onTenantUserSelect={onTenantUserSelect}
  />
)

HeaderContainer.displayName = 'Header'

HeaderContainer.propTypes = {
  onTenantUserSelect: PropTypes.func.isRequired
}

HeaderContainer.contextTypes = {
  router: PropTypes.object.isRequired
}

export default HeaderContainer



// WEBPACK FOOTER //
// ./src/components/header/container/index.js